/** User uploads only (not catalog samples). */
export function isUploadDatasetType(type) {
  return type === 'upload' || type === 'parquet' || type === 'csv';
}

/** Manteo-hosted datasets: uploads, samples, and legacy list types. */
export function isLocalDatasetType(type) {
  return isUploadDatasetType(type) || type === 'sample';
}

/** Human-friendly label for an upload table_id (matches backend get_table_display_name for uploads). */
export function uploadTableDisplayName(tableId) {
  if (!tableId) return 'Unknown';
  let name = tableId;
  if (name.startsWith('upload_')) {
    name = name.slice('upload_'.length);
  }
  return name;
}

export function buildOptimisticUploadDataset(tableId) {
  return {
    id: tableId,
    name: uploadTableDisplayName(tableId),
    type: 'upload',
    status: 'loading',
  };
}

/** Optimistic row for Data Sources list while upload metadata is loading. */
export function buildOptimisticDataSourcesDataset(tableId) {
  return {
    id: tableId,
    name: uploadTableDisplayName(tableId),
    type: 'upload',
    status: 'loading',
    size: 'N/A',
    date: 'Recent',
    created_at: new Date().toISOString(),
  };
}
